import {Component, OnInit, ViewChild, ElementRef, SimpleChanges, SimpleChange, Input} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import * as $ from 'jquery';
import {RouteReuseStrategy} from '@angular/router';


import {Zinuzh} from './Zinuzh';
import {HeaderBackgroundService} from '../header-background.service';
import {Globals} from '../globals';
import {Hayzinvor} from '../hayzinvor/Hayzinvor';

@Component({
  selector: 'app-zinuzh',
  templateUrl: './zinuzh.component.html',
  styleUrls: ['./zinuzh.component.scss'],

})
export class ZinuzhComponent implements OnInit {
  isShown: boolean = false;

  video = 'https://www.youtube.com/embed/zgRL2LWGC7E';
  zinuzh: Zinuzh;
  @ViewChild('smallvideoPlayer') videoplayer: ElementRef;
  videoFile;
  mySubscription: any;
  config: any = {
    //  effect:'fade',
    slidesPerView: 3,
    spaceBetween: 20,
    slidesPerGroup: 1,
    loop: false,
    loopFillGroupWithBlank: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 1,
      }
    }
  };
  config2: any = {
    //  effect:'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: false,

    zoomToggle: false,
    setWrapperSize: true,

  };

  // changeSrc() {
  //   $('.smallVideos object').on('click' , function() {
  //   var c =  $(this).attr('src');
  //   $('.video').find('video').attr('src', c)
  //   })
  // };


  somethingChanged: any;
  dataToSend: any;


  dateChanged(val: any) {
    var num;
    ;
    this.somethingChanged = val.value.toString().split(' ');
    if (this.somethingChanged[1] == 'Jan') {
      num = '01';
    } else if (this.somethingChanged[1] == 'Feb') {
      num = '02';
    } else if (this.somethingChanged[1] == 'Mar') {
      num = '03';
    } else if (this.somethingChanged[1] == 'Apr') {
      num = '04';
    } else if (this.somethingChanged[1] == 'May') {
      num = '05';
    } else if (this.somethingChanged[1] == 'Jun') {
      num = '06';
    } else if (this.somethingChanged[1] == 'Jul') {
      num = '07';
    } else if (this.somethingChanged[1] == 'Aug') {
      num = '08';
    } else if (this.somethingChanged[1] == 'Sep') {
      num = '09';
    } else if (this.somethingChanged[1] == 'Oct') {
      num = '10';
    } else if (this.somethingChanged[1] == 'Nov') {
      num = '11';
    } else if (this.somethingChanged[1] == 'Dec') {
      num = '12';
    }
    this.dataToSend = this.somethingChanged[3] + '-' + num + '-' + this.somethingChanged[2];
    // console.log(this.dataToSend)
    this.http.get<Zinuzh>(this.globals.urlMain + 'zinuj', {
      params: {
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.zinuzh = data;

    });

  }

  constructor(private http: HttpClient, public globals: Globals,
              private route: ActivatedRoute, public sanitizer: DomSanitizer,
              public headerBack: HeaderBackgroundService) {
    headerBack.canChange = true;
    headerBack.changeBg('../../assets/img/RepeatGrid3.png');
  }


  ngOnInit() {
    // console.log(this.headerBack.imagePath)
    // this.headerBack.imagePath = ';


    setTimeout(function () {


    }, 500);


    $(window).scrollTop(0);


    // this.changeSrc();


    this.http.get<Zinuzh>(this.globals.urlMain + 'zinuj').subscribe(data => {
      this.zinuzh = data;
      // this.videoFile = data.data.haxordum_video

    });
  }

  changeVideo(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    // var value = idAttr.nodeValue;

    var id = $(target).attr('data-id');
    var newImgsrc = $('.bigVideoZinujPage').find('img').attr('src');
    var newVideo = $('.bigVideoZinujPage').find('iframe').attr('src');
    var title_zinuj = $('.bigVideoZinujPage').find('.title_zinuj').html();
    var new_title_zinuj = $(target).data('title');
    var newsrc = $(target).closest('.zinujPageSmalls').find('img').attr('data-id');
    console.log(new_title_zinuj);
    console.log(title_zinuj);
    $('.bigVideoZinujPage').find('.title_zinuj').html(new_title_zinuj);
    $(target).data('title', title_zinuj);
    $('#' + id).find('.title').html(title_zinuj);

    var iframe = document.createElement('iframe');
    iframe.src = newsrc;
    iframe.height = '100%';
    iframe.width = '100%';
    $('.bigVideoZinujPage').find('img').attr('src', $(target).closest('.zinujPageSmalls').find('img').attr('src'));
    var oldIframe = document.createElement('img');
    oldIframe.src = newImgsrc;
    oldIframe.setAttribute('data-id', newVideo);
    oldIframe.style.height = '100%';
    oldIframe.style.width = '100%';
    // $(target).closest('.smallZinuj').remove();
    $('#' + id).find('img').remove();
    console.log(oldIframe);
    $('#' + id).find('.iframe').prepend(oldIframe);
    $('#' + id).find('.iframe').append($(target));

    $('.bigVideoZinujPage ').find('iframe').remove();
    $('.bigVideoZinujPage').prepend(iframe);

  };

  openModal(event) {
    let mainvideo = $('.myVideoClass').attr('src');
    $('.myVideoClass').attr('src', ' ');
    $('.myVideoClass').attr('src', mainvideo);
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    console.log($(target).closest('.itemContent'));
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }


  toggleShow() {

    this.isShown = !this.isShown;

  }

  sendXoragirId(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    var id = $(target).attr('data-id');

    // alert(id)
    this.http.get<Zinuzh>(this.globals.urlMain + 'zinuj', {
      params: {
        data: id,
      }
    }).subscribe(data => {
      this.zinuzh = data;
    });
    $('html, body').animate({
      scrollTop: $('.hayZinvorLast').offset().top
    });
  }

}
